import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=53e66d5d&scoped=true&"
import script from "./DetailHeader.vue?vue&type=script&lang=ts&"
export * from "./DetailHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e66d5d",
  null
  
)

export default component.exports